import { useEffect, useRef } from 'react'
import { useMap } from '@vis.gl/react-google-maps'

import { getGooglePlaceReverseGeocode } from '../../../Google.api'
import { toReverseGeocodeApiParams } from '../../../Google.utils'

import { SUPPRESS_MAP_CLICK_TIME } from './useGoogleMapMarkers.constants'

export function useGoogleMapMarkers({
  editMode,
  markers,
  toPreparedAddress,
  onChangeAddress,
  onMapClick,
}) {
  const map = useMap()

  const suppressMapClickRef = useRef(false)
  const suppressTimerRef = useRef(null)

  useEffect(() => {
    if (map && markers?.length === 1) {
      map.panTo(markers[0].position)
    }
  }, [markers])

  // After marker `onDragEnd` event map fires `onClick` and this callback will prevent this behaviour
  function setSuppressMapClickTimeout(ms = SUPPRESS_MAP_CLICK_TIME) {
    suppressMapClickRef.current = true

    if (suppressTimerRef.current) {
      clearTimeout(suppressTimerRef.current)
    }

    suppressTimerRef.current = setTimeout(() => {
      suppressMapClickRef.current = false
    }, ms)
  }

  function handleUpdateAddress(event) {
    getGooglePlaceReverseGeocode(
      toReverseGeocodeApiParams(event.detail.latLng)
    ).then(({ data }) => {
      // we must override `geometry.location` to user event values to place marker where user click
      onChangeAddress(toPreparedAddress(data, event))
    })
  }

  function handleMapClick(event) {
    // prevent click after `onDragEnd`
    if (suppressMapClickRef.current) {
      return
    }

    if (editMode) {
      onMapClick(event.detail.latLng)
      handleUpdateAddress(event)
    }
  }

  function handleMarkerDragEnd(event) {
    setSuppressMapClickTimeout()

    handleUpdateAddress({
      detail: {
        latLng: {
          lat: event.latLng.lat(),
          lng: event.latLng.lng(),
        },
      },
    })
  }

  function handleMarkerDragStart() {
    setSuppressMapClickTimeout()
  }

  return { handleMapClick, handleMarkerDragEnd, handleMarkerDragStart }
}
